import {map} from 'rxjs/operators';
import {Component, Inject, LOCALE_ID, OnDestroy} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material';
import {FormControl, Validators} from '@angular/forms';
import {Dataset, Folder, FourDService, Transform} from '4d-mapper';
import {Role, SearchResults, User, VasatSearchQuery} from 'vasat';
import {FileStub} from '../shared.module';
import {AppService} from '../app.service';
import {AclService} from '../acl/acl.service';
import {forkJoin, Observable} from 'rxjs';
import {formatDate} from '@angular/common';
import {TranslateService} from '@ngx-translate/core';
import {FourDInjector} from '../FourDInjector';

const _ = require('underscore')
const M = require('moment')

@Component({
  selector: 'app-dialog',
  templateUrl: './app-dialog.html',
  styleUrls: ['./app-dialog.scss']
})

export class AppDialog implements OnDestroy {

  nameControl = new FormControl('');
  inputControl = new FormControl('');
  inputControlURL = new FormControl('');
  inputControlMsg = new FormControl('');
  emailControl = new FormControl('');
  emailControlMsg = new FormControl('');
  meta: any

  query: any

  selectedFolder: Folder
  selectedFiles: Dataset[]

  type_Dataset = Dataset
  type_Transform = Transform


  selectedUser: User
  users: VasatSearchQuery<any>

  results: SearchResults<any>
  private isOver: boolean = false;
  public passedValue: any;

  // if we need to deal with permissions
  permission_options: any = null;

  // folder attributes
  folder_properties: any = null;

  // have we got options?
  haveOptions:boolean = false;

  // various options
  optionExpireDays:number = 7;
  optionEmailShareLink:boolean = false;


  translate: TranslateService = FourDInjector.injector.get(TranslateService);
  private progressFileId: any;


  roles:Role[] = []

  constructor(public dialogRef: MatDialogRef<AppDialog>, @Inject(MAT_DIALOG_DATA) public data: any, private fourD: FourDService, public permissions: AclService,
  public service: AppService, @Inject(LOCALE_ID) private locale: string, public dialog: MatDialog ) {
    
    // console.log ( 'app-dialog.ts :: constructor :: begin', this.data, this.inputControl );
    if (this.data.isExternalURL) {
      const reg = '(https?://)?([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-]*/?';
      this.inputControl.setValidators([Validators.minLength(1), Validators.maxLength(300)
        //, Validators.pattern(reg)
      ]);
    } else {
      this.inputControl.setValidators([Validators.required, Validators.minLength(2)]);
    }
    this.meta = data.meta || {};

    // console.log ( "app-dialog.ts :: constructor :: incoming input data", data.input );

    // incoming inputs?
    if ( data.input ) {

      if (typeof data.input.name !== 'undefined') {
        // incoming name field
        this.nameControl.setValue(data.input.name);
      }
  
      // input is an object, with values
      if ( typeof data.input.value !== 'undefined' ) {
        this.inputControl.setValue(data.input.value);
        this.passedValue = data.input.value;
        // console.log ('app-dialog.ts :: constructor :: setting object "value"', data.input );
      } else {
        // console.error ( '!!!', typeof data.input );
        if ( typeof data.input !== 'object' ) {
          this.inputControl.setValue(data.input);
          this.passedValue = data.input;
          // console.log ('app-dialog.ts :: constructor :: setting value', data.input );
        } else {
          this.inputControl.setValue(null);
        }
        
      }


      // input is a set of permissions (so, maybe we're sharing a link or something)
      if ( typeof data.input.permissions !== 'undefined' ) {
        this.permission_options = data.input.permissions;
      }

      if ( typeof data.input.folder_properties !== 'undefined' ) {
        this.folder_properties = data.input.folder_properties;
      }

    }


    this.fourD.V.searchByObject(Role).equals("desc","4D Public|4D Mapper").queryObservable().subscribe(s => {
      this.roles = s.items

    })

    if (this.data.mode == 'user') {
      this.users = this.fourD.V.searchByObject(User)
      this.users.queryObservable().subscribe(s => {
        this.results = s
      })
    }
    // console.log ( 'app-dialog.ts :: constructor :: end', this.data, this.inputControl );
  }

  onClick(res): void {

    // console.log ( 'app-dialog onClick', res, this.data);

    // clicked OK for choosing a folder
    if (this.data.mode == 'folder') {
      this.dialogRef.close(this.selectedFolder)
    }

    // clicked OK for choosing file(s)
    else if (this.data.mode == 'file' || this.data.mode == 'file_all') {

      if (this.data.input) {
        if (!res) {
          /*var okMSg, errMsg
          this.translate.get(['PROJECT.DELETE.SUCCESS', 'PROJECT.DELETE.ERROR']).map(params => {
            okMSg = params['PROJECT.DELETE.SUCCESS']
            errMsg = params['PROJECT.DELETE.ERROR']
          }).flatMap(e => {*/

          let dialogRef = this.dialog.open(AppDialog, {
            width: '350px',
            data: {
              title: 'PROJECT.DELETE.TITLE',
              text: 'PROJECT.DELETE.MSG',
              posBtn: 'GENERIC.YES',
              negBtn: 'GENERIC.NO',
              meta: {name: this.data.meta.name}
            }
          });
          dialogRef.afterClosed().subscribe(
            // flatMap(
            s => {
              if (s) {

                return this.data.meta.destroyObservable().subscribe(
                  s => {
                    this.data.meta['nuked'] = true
                    this.dialogRef.close({project: this.data.meta})
                  },
                  e => {
                    this.data.meta['nuked'] = 'Error';
                    this.dialogRef.close({project: this.data.meta})
                  }
                );
              }

            }
            /*}
            )*/
          )
          /*}).subscribe(
            s => {
              if (s) {
                // this.openSnackBarInfo(okMSg, null)
                this.data.meta['nuked'] = true
                this.dialogRef.close({project: this.data.meta})
              }
            },
            e => {this.data.meta['nuked'] = 'Error';
              this.dialogRef.close({project : this.data.meta})}
          );*/
          /*this.data.meta.destroyObservable().subscribe(
            s => {
              this.data.meta['nuked'] = true
              this.dialogRef.close({project: this.data.meta})
            },
            e => {this.data.meta['nuked'] = 'Error';
                    this.dialogRef.close({project : this.data.meta})}
          )*/
        } else {
          if (this.inputControl.value !== this.passedValue) {
            this.data.meta.project.name = this.inputControl.value;
            this.data.meta.project.saveObservable().subscribe(
              s => {
                this.data.project.meta['saved'] = true
                this.dialogRef.close({
                  selectedFiles: this.selectedFiles,
                  project: this.data.meta.project,
                  selectedFolder: this.selectedFolder
                });
              },
              e => {
                this.data.project.meta['saved'] = 'Error';
                this.dialogRef.close({
                  selectedFiles: this.selectedFiles,
                  project: this.data.meta.project,
                  selectedFolder: this.selectedFolder
                });
              }
            );
          } else {
            this.dialogRef.close({
              selectedFiles: this.selectedFiles,
              project: this.data.meta,
              selectedFolder: this.selectedFolder
            });
          }
        }

      } else {
        this.dialogRef.close({
            selectedFiles: this.selectedFiles,
          selectedFolder: this.selectedFolder
      });
      }

    }

    // clicked OK for choosing a user
    else if (this.data.mode == 'user') {
      this.dialogRef.close(this.selectedUser)
    }

    // clicked OK with permissions and options (a share link)
    else if (res && this.permission_options ) {
      if (this.nameControl.valid) {
        this.dialogRef.close({
          email: this.emailControl.value,
          name: this.nameControl.value,
          message: this.emailControlMsg.value,
          permissions: this.permission_options, // depricated, using roles
          roles: this.roles.filter(r => r['use']),
          expire: this.haveOptions ? this.optionExpireDays : false
        });
      }
    }

    // clicked OK, with folder attributes
    else if ( this.folder_properties ) {
      this.dialogRef.close({
        folder_properties: this.folder_properties
      });
    }

    // clicked OK, check for data input
    else if (this.data.input && this.data.input.copy) {
      this.copyLink(res, () => this.dialogRef.close(res))

    // all else
    } else {
      this.dialogRef.close(res)
    }

  }

  updateQuery(f: Folder) {
    const mainDiv = document.getElementById('mainDIV');
    mainDiv.scrollTop = 0;

    if (this.data.filter && this.data.filter !== 'Dataset') {
      this.query = {
        op: 'and',
        items: [
          {
            col: 'folder', op: '=', val: f.id
          },
          {
            col: 'transformType',
            op: 'in',
            ids: this.fourD.transformTypes.filter(t => {
              if (this.data.filter == 'photo-dzi') {
                return t.uid == this.data.filter || t.uid == 'thumb'
              }
              else
                return t.uid == this.data.filter
            }).map(t => t.id)
          }
        ]
      }
    }
    else {
      this.query = {
        col: 'folder', op: '=', val: f.id
      }
    }


  }

  setVal(f: Folder) {
    this.selectedFolder = f
    // once folder is selected, then unselect all selected files
    this.selectedFiles = undefined;
    /* const mainDiv = document.getElementById('mainDIV');
     mainDiv.scrollTop = 0;*/
  }

  copyLink(text: string, callback: Function) {
    var event = (e: ClipboardEvent) => {
      e.clipboardData.setData('text/plain', text);
      e.preventDefault();
      document.removeEventListener('copy', event);
      if (callback) callback()
    }
    document.addEventListener('copy', event);
    document.execCommand('copy');
  }

  dragOver(e: DragEvent) {
    e.preventDefault();
    this.isOver = true;
    return false;
  }

  dragLeave(e: DragEvent) {
    e.preventDefault();
    this.isOver = false;
    return false;
  }

  dropFiles(e: DragEvent) {
    if (e.stopPropagation)
      e.stopPropagation()

    e.preventDefault()

    var filez = e.dataTransfer.files;
    var l = filez.length
    var grp = _.groupBy(filez,
      (obj, i) =>
        '_' + Math.floor(i / 10)
    )
    this.fourD.V.searchByObject(Folder).equals('name', 'uploaded from ' + this.data.meta.name).queryObservable().subscribe(value => {
      if (value && value.items.length > 0) {
        var deQueue = () => {
          var a = Object.keys(grp)
          if (a.length) {
            var key = a[0]
            var items = grp[key]

            this._sendBatch(items, value.items[0]).subscribe(s => {
              delete grp[key]
              deQueue()
            })
          }
        }
        deQueue()
        this.isOver = false
        return false
      } else {
        var folder = new Folder(this.fourD.V)
        /*folder.name = this.data.meta.name + '_' +  (formatDate(new Date() , 'yyyy-MM-dd HH:mm:ss', this.locale));*/
        folder.name = 'uploaded from ' + this.data.meta.name;
        folder.saveObservable().subscribe(
          () => {
            var deQueue = () => {
              var a = Object.keys(grp)
              if (a.length) {
                var key = a[0]
                var items = grp[key]

                this._sendBatch(items, folder).subscribe(s => {
                  delete grp[key]
                  deQueue()
                })
              }
            }
            deQueue()
            this.isOver = false
            return false
          }
        )
      }
    });

  }

  uploadFiles(e) {
    var filez = e.srcElement.files
    var l = filez.length
    var grp = _.groupBy(filez,
      (obj, i) =>
        '_' + Math.floor(i / 10)
    )
    var folder = new Folder(this.fourD.V)
    folder.name = this.data.meta.name + '_' + (formatDate(new Date(), 'yyyy-MM-dd HH:mm:ss', this.locale));
    folder.saveObservable().subscribe(
      () => {
        var deQueue = () => {
          var a = Object.keys(grp)
          if (a.length) {
            var key = a[0]
            var items = grp[key]

            this._sendBatch(items, folder).subscribe(s => {
              delete grp[key]
              deQueue()
            })
          }
        }
        deQueue()
        return false
      }
    )
  }

  _sendBatch(files: File[], folder: Folder): Observable<FileStub[]> {

    var filesObs = files.map(v => {
      var name = v.name
      var blank = new Dataset(this.service.V).set({
        name: name,
        folder: folder,
        incomplete_offset: 0,
        incomplete_seq: 0,
        incomplete_total: length,
        incomplete: true
      })

      return blank.saveObservable().pipe(map(ds => {
        return {
          dataset: ds,
          file: v,
          valid: true
        }
      }))
    })

    return forkJoin(filesObs).pipe(map(res => {
      res.forEach(s => {
        if (s.valid) {
          console.log(s.dataset.id);
          this.progressFileId = s.dataset.id;
          this.fourD.uploadFile(s.dataset, s.file, 'data', 19000000);

        }
      })
      return res
    }))

  }

  ngOnDestroy(): void {

    this.selectedFolder = undefined;
  }

  openURL() {
    let url: string = '';
    if (!/^http[s]?:\/\//.test(this.inputControl.value)) {
      url += 'http://';
    }

    url += this.inputControl.value;
    window.open(url, '_blank');
  }

}
